/**
 * Centralized constants for Chatwoot provider
 *
 * Best Practices Implementation:
 * - Differentiated polling intervals (critical data: 20s, secondary data: 5min)
 * - Stale-while-revalidate caching (serve cached data instantly, revalidate in background)
 * - Rate limit optimizations to reduce API calls/minute
 *
 * Research: https://www.merge.dev/blog/api-polling-best-practices
 */

export const CHATWOOT_CONSTANTS = {
  // Pagination
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,

  // Differentiated Cache Strategy (Stale-While-Revalidate)
  // Research: https://dev.to/rigalpatel001/react-query-or-swr-which-is-best-in-2025-2oa3
  CACHE_STALE_TIME: 5 * 60 * 1000, // 5 minutes - for active conversations
  SNOOZED_CACHE_STALE_TIME: 10 * 60 * 1000, // 10 minutes - for snoozed counts (less critical)
  CACHE_MAX_SIZE: 100,

  // Retry
  MAX_RETRIES: 0, // Temporarily disabled due to 429 rate limiting
  RETRY_BACKOFF_MS: 1000,

  // Debounce
  SEARCH_DEBOUNCE_MS: 300,
  FILTER_DEBOUNCE_MS: 150,

  // Virtual scrolling
  CONVERSATION_ROW_HEIGHT: 88,
  MESSAGE_ROW_HEIGHT: 100,
  OVERSCAN_COUNT: 5,

  // Differentiated Polling Intervals
  // Native engine has no ActionCable — 30s fallback + notification-driven refresh.
  CONVERSATIONS_POLLING_INTERVAL: 30 * 1000, // 30s when WebSocket is disconnected
  SNOOZED_POLLING_INTERVAL: 5 * 60 * 1000, // 5 minutes - secondary data (snoozed counts)

  // WebSocket
  WEBSOCKET_RECONNECT_INTERVAL: 3000,

  // Toast
  TOAST_DURATION: 4000,
} as const;
